import { useStore } from 'zustand';

import { useCustomisableFormDataContext } from '../customisable-form-data/CustomisableFormDataContext';
import type { FormFieldElementsState } from './formFieldElementsStore';

export type {
  FieldElement,
  FormFieldElementsState,
  FormFieldElementsStore,
} from './formFieldElementsStore';
export { createFormFieldElementsStore } from './formFieldElementsStore';

export const useFormFieldElementsStore = <T>(
  selector: (state: FormFieldElementsState) => T
): T => {
  const { fieldElementsStore } = useCustomisableFormDataContext();

  return useStore(fieldElementsStore, selector);
};
